import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = { class: "text-danger text-center" }

import { computed, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { passwordUpdateSchema } from "@/schemas/account";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleOffcanvas } from "@/utils/Helper";
import { useUpdateUser } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordUpdate',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);
const errorMessage = ref("");

const { handleSubmit, meta } = useForm({
  validationSchema: toTypedSchema(passwordUpdateSchema),
  initialValues: {
    old_password: "",
    password: "",
    passwordConfirmation: "",
  },
});

const oldPasswordModel = useVeeField("old_password");
const passwordModel = useVeeField("password");
const passwordConfirmationModel = useVeeField("passwordConfirmation");

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    errorMessage.value = "";
    await updateUser({
      id: session.value!.id,
      old_password: values.old_password,
      password: values.password,
    });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Senha alterada",
      msg: "Sua senha foi alterada com sucesso",
    });
    toggleOffcanvas("offcanvas_views");
  } catch (error: any) {
    errorMessage.value = error.message;
  } finally {
    submitting.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PasswordInput, {
      label: "Senha",
      model: _unref(oldPasswordModel),
      placeholder: "Senha atual"
    }, null, 8, ["model"]),
    _createVNode(_component_PasswordInput, {
      label: "Nova senha",
      model: _unref(passwordModel),
      placeholder: "Mínimo de 8 caracteres"
    }, null, 8, ["model"]),
    _createVNode(_component_PasswordInput, {
      label: "Confirme a senha",
      model: _unref(passwordConfirmationModel),
      placeholder: "Confirme sua senha",
      errorMsg: "As senhas nao coincidem"
    }, null, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(errorMessage.value), 1)
      ])
    ]),
    _createVNode(_component_FormButton, {
      class: "w-100",
      label: "Concluir",
      disabled: !_unref(meta).valid,
      onOnClick: _unref(submit),
      marginVertical: false,
      loading: submitting.value
    }, null, 8, ["disabled", "onOnClick", "loading"])
  ]))
}
}

})